import React from 'react';
import PropTypes from 'prop-types';
import { ExclamationTriangleIcon } from './icons/ExclamationTriangleIcon';

export const ErrorMessage = ( { text='', allowClose=false, clearError = () => {} , filler = true}) => {

    // Props (errormsg, allowClose)
    // errormsg    = text string in the following format=>  message label: error message
    // allowClose  = true | false; set to true if you would like to allow user to close out error message themselves
    // clearError  = if allowClose is true, you must pass in function prop that will be 
    //               used (called) to clear the error message when user x's out error msg.
    // noFiller    = is used to maintain filler error to display message when there is no error

    // This component will be called upon each render. If  errormsg is empty, this component 
    // will render a filler area to avoid a page shift when error message is displayed

    // if (text === '' && filler) {             /* No message text was provided */
    if (text === '' && filler) {             /* No message text was provided */
        return <p className="errmsg-filler">&nbsp;</p>
    } else {                       /* message text provided */
        // Split message between label and message
        let messageArray = text.split(':');
        let [ messageLabel, message ] =  messageArray;

        // Return message JSX
        return (
            <div className="errmsg-container">
                <div>
                    <ExclamationTriangleIcon />
                    <span className="errmsg-label">{`${messageLabel}: `}</span>
                    <span className="errmsg-text">{message}</span>
                </div>
                {allowClose  && <div className="errmsg-close" onClick={clearError}>X</div>}
            </div>
        )
    }
}

ErrorMessage.propTypes = {
    text:       PropTypes.string.isRequired,
    allowClose: PropTypes.bool,
    clearError: PropTypes.func
};


// <div className="errmsg-container">
//                 <div>
//                     <ExclamationTriangleIcon />
//                     <span className="errmsg-label">{`${messageLabel}: `}</span>
//                     <span className="errmsg-text">{message}</span>
//                 </div>
//                 {allowClose  && <div className="errmsg-close" onClick={clearError}>X</div>}
//             </div>


// WEBPACK FOOTER //
// ./src/components/ErrorMessage.js